import AuthLayout from './AuthLayout';
import { Form, Input, message } from 'antd';
import SubmitBtn from './SubmitBtn';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { InputOTP } from 'antd-input-otp';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { useState } from 'react';
import useSignIn from '../../_hooks/useSignIn';
import { observer } from 'mobx-react-lite';

const NewPassword = observer(() => {
    const navigate = useNavigate();

    return (
        <div>
            <AuthLayout
                isBack={
                    <div
                        className="flex items-center gap-2 text-theme-icon-color mb-[10px] cursor-pointer"
                        onClick={() => navigate('/auth/login')}>
                        <IoArrowBack className="text-xl text-theme-icon-color" />
                        <span className="font-favorit font-[500] text-[14px]">
                            Back
                        </span>
                    </div>
                }
                title="Email verification"
                subtitle="Verify your email"
                content={<NewPasswordForm />}
            />
        </div>
    );
});

export default NewPassword;
const NewPasswordForm = observer(() => {
    const [form] = Form.useForm();
    const [isTimerFinished, setIsTimerFinished] = useState(false);

    const navigate = useNavigate();
    const { state } = useLocation();
    const { resetPasswordOtp, isLoading, confirmPasswordReset } = useSignIn();

    const handleResendCode = () => {
        resetPasswordOtp(state?.email)
            .then((result) => {
                message.success('Verification code sent to your email');
                setIsTimerFinished(false);
            })
            .catch((error) => {
                message.error(error.message);
            });
    };

    const onFinish = (values) => {
        const { otp, password } = values;
        const otpNumber = otp.join('');
        confirmPasswordReset(state?.email, otpNumber, password)
            .then((result) => {
                message.success('Password reset successfully');
                navigate('/auth/login');
            })
            .catch((error) => {
                message.error(error.message);
            });
    };

    return (
        <>
            <div>
                <p className="text-[14px] font-medium text-[#5B5F5D] font-favorit mb-[4px]">
                    We&apos;ve sent a verification code to your email address:{' '}
                    {state.email ? state.email : ''}
                </p>
                <span
                    className="font-favorit font-[500] text-[14px] text-theme-orange cursor-pointer hover:underline"
                    onClick={() => navigate('/auth/forgot-password')}>
                    Change Email ID
                </span>{' '}
            </div>
            <Form
                form={form}
                name="login"
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
                autoComplete="off"
                className="auth-form-antd mt-[10px]">
                {/* otp */}
                <div className="flex w-full justify-between ">
                    <Form.Item
                        name="otp"
                        className="mb-[16px] custom-otp-input"
                        rules={[
                            {
                                validator: async (_, value) => {
                                    if (
                                        !value ||
                                        value.includes(undefined) ||
                                        value.includes('')
                                    ) {
                                        return Promise.reject(
                                            new Error(
                                                'Please enter a valid OTP!',
                                            ),
                                        );
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}>
                        <InputOTP
                            autoFocus
                            inputType="numeric"
                            length={6}
                            placeholder="-"
                            className="otp-input"
                            autoComplete="one-time-code"
                        />
                    </Form.Item>
                    <div className="flex  w-[78px] h-[40px] items-center">
                        {isTimerFinished ? (
                            <span
                                onClick={() => {
                                    handleResendCode();
                                }}
                                className=" text-[12px] font-favorit text-theme-orange cursor-pointer underline leading-[12px] ">
                                Resend Code
                            </span>
                        ) : (
                            <CountdownCircleTimer
                                isPlaying={!isTimerFinished}
                                duration={15}
                                colors={[['#F46147']]}
                                size={36}
                                strokeWidth={3}
                                onComplete={() => setIsTimerFinished(true)}>
                                {({ remainingTime }) => (
                                    <div className="text-[12px] text-[#8C8C8C] font-favorit">
                                        {remainingTime + 's'}
                                    </div>
                                )}
                            </CountdownCircleTimer>
                        )}
                    </div>
                </div>

                <p className="font-favorit font-[500] text-[14px] text-[var(--primary-color13)] mb-[10px]">
                    Enter a new password
                </p>

                <Form.Item
                    className="mb-[16px]"
                    name="password"
                    label="Password *"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter your password!',
                        },
                    ]}>
                    <Input.Password
                        placeholder="Enter your password"
                        className="auth-form-antd-form-item"
                        autoComplete="new-password"
                    />
                </Form.Item>

                <Form.Item
                    className="mb-[16px]"
                    name="confirm"
                    label="Confirm Password *"
                    dependencies={['password']}
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password!',
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (
                                    !value ||
                                    getFieldValue('password') === value
                                ) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(
                                    new Error('Passwords do not match!'),
                                );
                            },
                        }),
                    ]}>
                    <Input.Password
                        placeholder="Confirm your password"
                        className="auth-form-antd-form-item"
                        autoComplete="new-password"
                    />
                </Form.Item>

                <Form.Item className="mb-[16px]">
                    <SubmitBtn
                        label="Reset Password"
                        className="w-full"
                        isLoading={isLoading}
                    />
                </Form.Item>
            </Form>
        </>
    );
});
